module.exports = __webpack_public_path__ + "static/media/BudgetSmartSlide03.ef36a293.jpg";